import { ref } from 'vue'

export const tokenStore = {
  token: ref(''),
  setToken(value) {
    this.token.value = value
  },
}
